import moment from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { BudgetItem } from './budget-item';
import { Category } from './accounting/category';
import { Organization } from './organization';
import Moment = moment.Moment;

export class Budget
{
    id: number;
    organizationId: number;
    name: string;
    createdAt: Moment;
    updatedAt: Moment;
    deletedAt: Moment;

    organization: Organization;
    budgetItems: BudgetItem[];
    categories: Category[];

    constructor(budget: any) {
        if (budget.id) {
            this.id = budget.id;
        }
        if (budget.organizationId) {
            this.organizationId = budget.organizationId;
        }
        if (budget.name) {
            this.name = budget.name;
        }

        const timezone = LegFiJwtService.getTimezone();
        if (budget.createdAt) {
            this.createdAt = moment.utc(budget.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (budget.updatedAt) {
            this.updatedAt = moment.utc(budget.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (budget.deletedAt) {
            this.deletedAt = moment.utc(budget.deletedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }

        if (budget.organization) {
            this.organization = new Organization(budget.organization);
        }
        if (budget.budgetItems) {
            this.budgetItems = budget.budgetItems.map(
                    (budgetItem) => {
                        return new BudgetItem(budgetItem);
                    },
            );
        }
        if (budget.categories) {
            this.categories = budget.categories.map(
                    (category) => {
                        return new Category(category);
                    },
            );
        }
    }
}
